package com.speedsoftware.nibbler

import web.navigator.navigator

class JsPlatform: Platform {
    private val userAgent = navigator.userAgent
    private val browserList = listOf("Chrome", "Firefox", "Safari", "Edge")

    override val name: String = userAgent.findAnyOf(browserList, ignoreCase = true)
            ?.let { (startIndex) -> userAgent.substring(startIndex).substringBefore(" ") }
            ?: "Unknown"
}

actual fun getPlatform(): Platform = JsPlatform()

actual fun getDefaultServerUrl(): String {
    return try {
        val origin = kotlinx.browser.window.location.origin
        if (origin.contains(":8081")) {
            "http://localhost:8080"
        } else if (origin.isNotBlank() && origin != "null") {
            origin
        } else {
            "http://localhost:8080"
        }
    } catch (_: Throwable) {
        "http://localhost:8080"
    }
}

actual fun getInitialUrlToken(): String? {
    return try {
        val search = kotlinx.browser.window.location.search
        val params = search.removePrefix("?").split("&")
        val tokenParam = params.firstOrNull { it.startsWith("token=") || it.startsWith("invite=") }
        tokenParam?.substringAfter("=")?.takeIf { it.isNotBlank() }
    } catch (_: Throwable) {
        null
    }
}

actual fun getInitialResetToken(): String? {
    return try {
        val search = kotlinx.browser.window.location.search
        val params = search.removePrefix("?").split("&")
        val resetParam = params.firstOrNull { it.startsWith("reset=") }
        resetParam?.substringAfter("=")?.takeIf { it.isNotBlank() }
    } catch (_: Throwable) {
        null
    }
}

actual fun isSameOriginServer(serverUrl: String): Boolean = try {
    val origin = kotlinx.browser.window.location.origin
    origin.isNotBlank() && origin != "null" && serverUrl.trim().trimEnd('/') == origin
} catch (_: Throwable) {
    false
}

actual fun loadStoredThemeMode(): String? = try {
    kotlinx.browser.localStorage.getItem("nibbler.theme")
} catch (_: Throwable) {
    null
}

actual fun storeThemeMode(mode: String) {
    try {
        kotlinx.browser.localStorage.setItem("nibbler.theme", mode)
    } catch (_: Throwable) {
    }
}

actual fun systemPrefersDarkTheme(): Boolean = try {
    kotlinx.browser.window.matchMedia("(prefers-color-scheme: dark)").matches
} catch (_: Throwable) {
    true
}

actual fun loadStoredSession(): StoredSession? = null

actual fun storeSession(session: StoredSession?) {}

actual fun isMobileApp(): Boolean = false
